import React from 'react'

const Warning = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16">
      <g transform="rotate(180 774.5 27.5)">
        <g fill="#fff" transform="translate(-.358 -1.639)">
          <circle cx="1.134" cy="1.134" r="1.134" transform="rotate(180 771.246 22.823)"></circle>
          <path
            d="M1 0a1 1 0 00-1 1v5a1 1 0 002 0V1a1 1 0 00-1-1z"
            transform="rotate(180 771.17 26.882)"
          ></path>
        </g>
      </g>
    </svg>
  )
}

export default React.memo(Warning)
